import { consoleRequest } from '@/console/api/http'
import {
  ConfirmGlobalInboundRequest,
  ConfirmGlobalInboundResponse,
  GlobalInboundRollbackRequest,
  GlobalInboundRollbackResponse,
} from '@/console/api/types'

/**
 * 글로벌 입고확정 롤백 · 재확정(docs/GLOBAL_INBOUND_ROLLBACK_API.md §3).
 * 롤백은 성공 본문에 `meta` 래퍼가 없어(규약 B) 그대로 돌려주고, 재확정은 규약 A 라 `data.items` 를 꺼낸다.
 * 두 호출 모두 재시도하지 않는다 — 실행은 문서 단위로 되돌리므로 결과는 다시 판정해서 확인한다.
 */
const ROLLBACK_URL = '/api/v1/confirm-global-inbounds/rollback'
const CONFIRM_URL = '/api/v1/confirm-global-inbounds'

export const requestGlobalInboundRollback = (request: GlobalInboundRollbackRequest): Promise<GlobalInboundRollbackResponse> =>
  consoleRequest.post<GlobalInboundRollbackResponse, GlobalInboundRollbackRequest>(ROLLBACK_URL, request)

/** 생성된 입고지시 ID 목록을 돌려준다. */
export const requestConfirmGlobalInbound = async (request: ConfirmGlobalInboundRequest): Promise<number[]> => {
  const response = await consoleRequest.post<ConfirmGlobalInboundResponse, ConfirmGlobalInboundRequest>(CONFIRM_URL, request)
  return response.data.items
}
